export const NAME_SPACE = 'AssetView';
export const ROOT_STATE_KEY = 'Exports';
